module.exports = __webpack_public_path__ + "img/img4.9fccee03.png";